import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import { AuctioneerCTAs } from './components/AuctioneerCTAs/AuctioneerCTAs';
import { AuctioneerDetails } from './components/AuctioneerDetails/AuctioneerDetails';
import { RatingContainer } from './components/RatingContainer/RatingContainer';

type Props = {
    itemId: number;
    sellerId: number;
};

export const AuctioneerInfo = ({ itemId, sellerId }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <div className="flex flex-col gap-sm">
            <div>
                <H5 className="mb-xs">{formatMessage({ id: 'itemPage.auctionHouse.title' })}</H5>
                <AuctioneerDetails sellerId={sellerId} />
            </div>
            <RatingContainer sellerId={sellerId} />
            <AuctioneerCTAs itemId={itemId} />
        </div>
    );
};
